import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MAIN_ENV } from '../../constants/global.constants';
import { useGetStrapiContentQuery } from '../../redux/api/strapiApi';
import { selectFeeFlag, selectStrapiLoading, setFeeFlag } from '../../redux/store/strapi/strapiSlice';

export const useFeeFlag = () => {
  const dispatch = useDispatch();
  const dataFeeFlag = useSelector(selectFeeFlag);
  const loading = useSelector(selectStrapiLoading);

  // Para MX: setear el estado directamente sin hacer petición
  useEffect(() => {
    if (MAIN_ENV.COUNTRY === 'MX' && dataFeeFlag === null) {
      dispatch(setFeeFlag(false));
    }
  }, [dispatch, dataFeeFlag]);

  // Usar RTK Query para hacer la petición (skip para MX o si ya tenemos datos)
  useGetStrapiContentQuery('brokers_legalizador', {
    skip: MAIN_ENV.COUNTRY === 'MX' || dataFeeFlag !== null,
  });

  return { dataFeeFlag, loading };
};
